import * as yup from 'yup';
import * as Yup from 'yup';

export const getStatusBadgeClass = (status) => {
    switch (status) {
        case 'planned':
            return 'bg-theme1-pink';
        case 'ongoing':
            return 'bg-theme1-info';
        case 'completed':
            return 'bg-theme1-success';
        case 'canceled':
            return 'bg-theme1-brightRed';
        default:
            return 'bg-gray-300';
    }
};
export const PROJECT_SCHEMA = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    description: Yup.string().nullable(),
    status: Yup.string().nullable(),
    budget: Yup.string().nullable(),
    actual_costs: Yup.string().nullable(),
    start_date: Yup.date()
        .nullable()
        .transform((value, originalValue) => (originalValue === '' ? null : value)),

    end_date: Yup.date()
        .nullable()
        .transform((value, originalValue) => (originalValue === '' ? null : value))
        .min(Yup.ref('start_date'), 'End Date cannot be before Start Date'),
    needs: yup
        .array()
        .of(
            yup.object().shape({
                id: yup.string().optional()
            }),
            yup.object().shape({
                name: yup.string().optional()
            }),
            yup.object().shape({
                need_id: yup.string().required()
            })
        )
        .optional(),
    capabilities: yup
        .array()
        .of(
            yup.object().shape({
                id: yup.string().optional()
            }),
            yup.object().shape({
                name: yup.string().optional()
            }),
            yup.object().shape({
                capability_id: yup.string().required()
            })
        )
        .optional()
});
